module.exports = __webpack_public_path__ + "static/media/stopwatch.7c122b6e.svg";